import { SET_CALLING_PROVIDER_SETTING } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageSetCallingProviderSettings(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: SET_CALLING_PROVIDER_SETTING,
      data
    });
  }
}